// src/constants/PatientViewFilters.js

const BillingViewFilters = {
  default: [
    {
      label: "Status",   
      key: "isactive",
      options: ["Active", "Inactive", "Pending", "Completed"],
    },
    {
      label: "Gender",
      key: "gender",
      options: ["Male", "Female", "Other"],
    },
  ],
  gst: [
    {
      label: "Distributor",
      key: "isactive",
      options: ["GST Registered", "Non GST Registered"],
    }
    
  ],
   stock: [
    {
      label: "Status",
      key: "isactive",
      options: ["Available", "UnAvailable", "LowStock"],
    }
    
  ],
stockFilters: [
    {
      label: "Status",
      key: "isactive",
      options: ["In Stock", "Out of Stock"],
    },
    {
      label: "Category",
      key: "category",
      options: ["Ayurvedic Care","Surgicals & Medical Devices","Mother & Baby Care","Personal Care & Hygiene","Medication","Beauty & Skin Care","Sexual Wellness","Food & Nutrition"],
    },
    
  ],
   additionalStock: [
    {
      label: "Form",                                        
      key: "form",
      options: [" Tablet", "Syrup", "Capsule", "Injection", "Cream", "Drops", "Powder", "Liquid", "Gel"],
    },
    {
      label: "Date",
      key: "insertedDate",
      operator: "Between",
      inputType: "date-range",
    },
  ],

  additional: [
       {
      label: "Age",
      key: "age",
      options: ["0-18", "19-35", "36-60", "60-75", "75-100"],
      operator: "Between",
      inputType: "single-select",
    },
    {
      label: "Allergies",
      key: "allergies",
      options: ["Peanuts", "Gluten", "Lactose", "Pollen"],
    },
    {
      label: "Blood Group",
      key: "blood_group",
      options: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],
    },
    {
      label: "Date",
      key: "insertedDate",
      operator: "Between",
      inputType: "date-range",
    },
  ],

  additionalPurchase: [
    {
      label: "Date",
      key: "insertedDate",
      operator: "Between",
      inputType: "date-range",
    },
  ]
};

export default BillingViewFilters;
